import { PropsWithChildren, ReactNode, useCallback } from 'react';

import { RolePermission } from '../../types/user.type';

type Props = PropsWithChildren & {
    permissions?: RolePermission[];
    requiredPermission?: string;
    menuSpace?: boolean;
};

const View = ({
    children,
    permissions,
    requiredPermission,
    menuSpace = true,
}: Props) => {
    const renderByPermissions: () => ReactNode = useCallback(() => {
        if (!requiredPermission) return children;
        const permission = permissions?.find(
            (per) => per.name === requiredPermission
        );
        if (!permission) return <NoPermissions />;

        return children;
    }, [children, permissions, requiredPermission]);

    return (
        <main className="view" style={{ marginLeft: menuSpace ? 240 : 0 }}>
            {renderByPermissions()}
        </main>
    );
};

const NoPermissions = () => (
    <div
        style={{
            display: 'flex',
            flex: 1,
            alignItems: 'center',
            justifyContent: 'center',
        }}
    >
        <span style={{ fontSize: 18 }}>
            No tienes permisos para acceder a esta vista
        </span>
    </div>
);

export default View;
